<template>
  <div class="notepad-container">
    <div class="body">
      <v-tooltip left>
        <v-btn slot="activator" small fab color="#00acc2" @click="openNotepad">
          <v-icon color="#fff" medium>edit_note</v-icon>
        </v-btn>
        <span>Bloco de Notas</span>
      </v-tooltip>
      <div>
      <v-layout v-if="firstTime" v-show="showNotepad" row justify-center>
        <v-dialog v-if="fullscreen" :value="showNotepad" scrollable fullscreen hide-overlay transition="dialog-bottom-transition">
          <p-notepad class="notepad" fixed @returnFirstTime="returnFirstTime" @closeNotepad="showNotepad = false" @openFullscreen="fullscreen = !fullscreen" :fullscreen="fullscreen"></p-notepad>
        </v-dialog>
        <p-notepad v-else class="notepad" fixed @returnFirstTime="returnFirstTime" @closeNotepad="showNotepad = false" @openFullscreen="fullscreen = !fullscreen" :fullscreen="fullscreen"></p-notepad>
      </v-layout>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .notepad-container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
  }
  .notepad {
     z-index: 2!important;
   }
</style>

<script>
  import PNotepad from './PNotepad.vue'

  export default {
    components: {PNotepad},
    data () {
      return {
        fullscreen: false,
        showNotepad: false,
        // firstTime usado para carreagr os dados a primeira vez q o usuário entra, pra depois não precisar ficar carregando, ou não carregar antes de entrar
        firstTime: false
      }
    },
    created () {
      this.fullscreen = this.$vuetify.breakpoint.smAndDown || !navigator.onLine
    },
    methods: {
      openNotepad () {
        this.showNotepad = !this.showNotepad
        this.firstTime = true
      },
      // returnFirstTime metodo criado para fechar o cbloco de notas e parar de carregar as informações. Necessário quando o usuário abrir outra aba com o bloco e uma aba não ficar atrapalhando a outra
      returnFirstTime () {
        this.showNotepad = false
        this.firstTime = false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/shared/PNotepadLauncher.vue